var React = require('react');

function TwitterFooter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.667 0a6.667 6.667 0 100 13.334A6.667 6.667 0 006.667 0zm3.353 5.518c.098 2.175-1.524 4.6-4.395 4.6a4.373 4.373 0 01-2.37-.695 3.11 3.11 0 002.289-.64 1.55 1.55 0 01-1.445-1.074c.242.046.48.033.698-.026a1.547 1.547 0 01-1.24-1.536c.209.115.447.185.701.193a1.547 1.547 0 01-.479-2.064 4.39 4.39 0 003.187 1.616 1.548 1.548 0 012.635-1.411c.352-.069.683-.198.982-.375a1.548 1.548 0 01-.68.855c.313-.037.611-.12.888-.243-.207.31-.469.582-.771.8z"}));
}

TwitterFooter.defaultProps = {"width":"13.333","height":"13.333","viewBox":"0 0 13.333 13.333"};

module.exports = TwitterFooter;

TwitterFooter.default = TwitterFooter;
